import { useCallback } from 'react';
import { useGetTodoTypeLabel } from 'views/Todo/hooks/useLabel';

export function useResolveTodoTypeLabel() {
  const { getTodoTypeLabel } = useGetTodoTypeLabel();

  return useCallback(
    (todoType?: string) => {
      if (!todoType) return undefined;

      if (/^-?\d+$/.test(todoType)) {
        return getTodoTypeLabel(Number(todoType) as Todo.Type, todoType) ?? todoType;
      }

      return todoType;
    },
    [getTodoTypeLabel],
  );
}
